import { invokeFunction } from '../api'
import { toApiRequestError } from '../errors'

export interface ComplianceTrendPoint {
  period_start: string
  overall_score: number
  cms_outcome: 'meets_standard' | 'conditional' | 'at_risk'
  cms_outcome_label: string
}

export interface CorrectiveActionSummary {
  open: number
  in_progress: number
  completed: number
  verified: number
  overdue: number
}

export async function getCorrectiveActionSummary(facilityId?: string): Promise<CorrectiveActionSummary> {
  let path = '/corrective-actions'
  if (facilityId) path += `?facility_id=${facilityId}`

  const { data, error } = await invokeFunction<{ summary: CorrectiveActionSummary }>('dashboards', {
    method: 'GET',
    path,
  })

  if (error) throw toApiRequestError(error, 'Failed to load corrective action summary')
  return data?.summary ?? { open: 0, in_progress: 0, completed: 0, verified: 0, overdue: 0 }
}

export async function getComplianceTrends(windowDays = 365, facilityId?: string): Promise<ComplianceTrendPoint[]> {
  let path = `/compliance-trends?window_days=${windowDays}`
  if (facilityId) path += `&facility_id=${facilityId}`

  const { data, error } = await invokeFunction<{ compliance_trends: { points: ComplianceTrendPoint[] } }>('dashboards', {
    method: 'GET',
    path,
  })

  if (error) throw toApiRequestError(error, 'Failed to load compliance trends')

  const points = data?.compliance_trends?.points
  return Array.isArray(points) ? points : []
}

